import { useSyncExternalStore } from 'react'

export type Country = 'FR' | 'BE'

// Country of a country config code, undefined for a country the subflow does not serve
export const toCountry = (countryCode?: string | null): Country | undefined =>
  countryCode === 'FR' || countryCode === 'BE' ? countryCode : undefined

// Country of the subflow domain opened by the prospect, France by default
export const countryOfHost = (host: string): Country =>
  host === process.env.NEXT_PUBLIC_APP_HOST_BE ? 'BE' : 'FR'

// The domain does not change while the page is open
const subscribeToHost = () => () => {}

// Country of the subflow domain; France while rendered on the server
export const useCountry = () =>
  useSyncExternalStore(
    subscribeToHost,
    () => countryOfHost(window.location.host),
    (): Country => 'FR'
  )
